import {useEffect, useState} from 'react';
import {callFunction} from '-/data/utils';

// Check visibility without downloading course details, reservations or nominees.
export default function useRegionalCalendarAvailable(enabled, scope) {
    const key = enabled ? scope : null;
    const [state, setState] = useState(null);
    useEffect(() => {
        if (!key) { setState(null); return undefined; }
        let active = true, inFlight = false;
        const load = async () => {
            if (inFlight) return;
            inFlight = true;
            try {
                const result = await callFunction('regionalCalendarAvailable', {});
                if (active) setState({key, available: result.available === true});
            } catch {
                // callFunction reports failures; don't expose an unavailable menu.
                if (active) setState({key, available: false});
            } finally { inFlight = false; }
        };
        const refreshVisible = () => { if (document.visibilityState !== 'hidden') load(); };
        load();
        const interval = window.setInterval(refreshVisible, 60000);
        window.addEventListener('focus', refreshVisible);
        document.addEventListener('visibilitychange', refreshVisible);
        return () => {
            active = false;
            window.clearInterval(interval);
            window.removeEventListener('focus', refreshVisible);
            document.removeEventListener('visibilitychange', refreshVisible);
        };
    }, [key]);
    return Boolean(key && state?.key === key && state.available);
}
